import ViewerItem from '@/views/components/viewer/item_v1.vue'
import Attachments from '@/views/components/file/attachments.vue'
import Effect from '@/views/blogger/records/components/Effect.jsx'
import { publish_form_list, service_in_types } from '@/views/blogger/fields.js'
export default {
    computed: {
        common_placing_ads_vas_record_fields() {
            return [
              {
                text: '加成服务编号',
                align: 'center',
                value: 'uid',
                width: 120,
            }, 
            {
                text: '服务时间',
                align: 'center',
                value: 'service_date',
                width: 120,
            },
            // {
            //     text: '投放类型',
            //     align: 'center',
            //     value: 'service_type',
            //     width: 120,
            //     type: 'list_field',
            //     item_key: 'value',
            //     item_text: 'label',
            //     items: service_in_types
            // },
            {
                text: '服务类型',
                align: 'center',
                value: 'service_type',
                width: 120,
                type: 'list_field',
                item_key: 'value',
                item_text: 'label',
                items: service_in_types
            },
            {
                text: '服务金额',
                align: 'center',
                value: 'total_price',
                type: 'money_field',
                width: 120,
            },
            {
                text: '合同编号',
                align: 'center',
                value: 'placing_ads_contract',
                width: 120,
                render:(_, t) => {
                    if (!t.placing_ads_contract || !t.placing_ads_contract.contract_id) {
                        return '-'
                    }
                    const type = t.placing_ads_contract.contract_type === 'Contract' ? 'Contract' : 'OutsourceContract'
                    return <div>
                    <ViewerItem type={type} modelId={t.placing_ads_contract.contract_id || 0}>
                       <a>
                        {t.placing_ads_contract.contract_uid}
                       </a> 
                    </ViewerItem>
                </div>
                } 
            },
            {
              text: '附件',
              align: 'center',
              value: 'bfiles',
              width: 120,
              render:(_, t) => {
                  if (!t.bfiles || !t.bfiles.length) {
                      return '-'
                  }
                  return <div>
                  <Attachments files={t.bfiles}/>
              </div>
              } 
            },
            ]
          },
        common_placingadsrecord_fields() {
            return [
                {
                    text: '投放编号',
                    align: 'center',
                    value: 'uid',
                    width: 240,
                }, 
                {
                    text: '发布时间',
                    align: 'center',
                    value: 'publish_at',
                    width: 120,
                },
                {
                    text: '发布类型',
                    align: 'center',
                    value: 'publish_form',
                    type: 'list_field',
                    item_key: 'value',
                    item_text: 'label',
                    items:publish_form_list,
                    width: 120,
                },
                {
                    text: '投放链接',
                    width: 140,
                    value: 'placing_ads_url',
                    renderv:(_, value) => {
                        
                        if (!value) {
                            return <span>-</span>
                        }
                        return <div><a href={value} target="__blank">投放链接🔗</a></div>
                    }
                },
                {
                    text: '对接人',
                    align: 'center',
                    value: 'docking_customer_name',
                    width: 120,
                },
                {
                    text: '项目组',
                    align: 'center',
                    type: 'team_field',
                    value: 'team_id',
                    width: 120,
                },
                {
                    text: '投放SKU',
                    align: 'center',
                    value: 'sku',
                    width: 120,
                    render:(_, t) => <div>{t.sku && t.sku.full_name || '-'}</div>
                },
                {
                    text: '预计投放金额',
                    align: 'center',
                    value: 'total_price',
                    type: 'money_field',
                    width: 120,
                },
                {
                    text: '实际消耗',
                    type: 'money_field',
                    align: 'center',
                    value: 'payable_price',
                    width: 120,
                },
                {
                    text: '付款进度',
                    type: 'money_field',
                    align: 'center',
                    value: 'paid_price',
                    width: 120,
                },
                {
                    text: '消耗进度',
                    type: 'money_field',
                    align: 'center',
                    value: 'consume_price',
                    width: 120,
                },
                // {
                //     text: '投放类型',
                //     align: 'center',
                //     value: 'placing_type',
                //     width: 120,
                //     type: 'list_field',
                //     item_key: 'value',
                //     item_text: 'label',
                //     items: put_in_types
                // },
                {
                    text: '附件',
                    align: 'center',
                    value: 'bfiles',
                    width: 120,
                    render:(_, t) => {
                        if (!t.bfiles || !t.bfiles.length) {
                            return '-'
                        }
                        return <div>
                        <Attachments files={t.bfiles}/>
                    </div>
                    } 
                },
                {
                  text: '效果',
                  align: 'center',
                  value: 'xiaoguo',
                  width: 300,
                  render:(_, t) => {
                      return <div>
                        <Effect value={t} showList={[ 2, 3]}/>
                  </div>
                  } 
                }
            ]
          },
    }
}